// Third-Party
import { IconButton, Stack, Tooltip } from "@mui/material";
import { Copy, RotateCw } from "lucide-react";

// Internal
import useCopyToClipboard from "@hooks/useCopyToClipboard";

interface IAIMessageActionsProps {
  messageId: string;
  content: string;
  translate: (text: string, options?: any) => string;
  onRegenerate?: (messageId: string) => void;
  isRegeneration?: boolean;
}

export const AIMessageActions: React.FC<IAIMessageActionsProps> = (props) => {
  const { messageId, content, translate, onRegenerate, isRegeneration } = props;
  const { copied, handleCopy } = useCopyToClipboard();

  if (isRegeneration) return null;

  return (
    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
      <Tooltip title={copied ? translate("copied") : translate("copy")}>
        <IconButton size="small" onClick={() => handleCopy(content)}>
          <Copy size={16} />
        </IconButton>
      </Tooltip>
      {onRegenerate && (
        <Tooltip title={translate("regenerate")}>
          <IconButton size="small" onClick={() => onRegenerate(messageId)}>
            <RotateCw size={16} />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};
